import React from 'react';
import { Component } from 'react';
// import SnowStorm from 'react-snowstorm';


const DanceOnSnow = () => {
    return (
        <div class="snowflakes" aria-hidden="true" style={{backgroundColor: "white"}}>
      
          <div class="snowflake">
          ❅
          </div>
          <div class="snowflake">
          ❅
          </div>
          <div class="snowflake">
          ❆
          </div>
          <div class="snowflake">
          ❄
          </div>
          <div class="snowflake">
          ❅
          </div>
          <div class="snowflake">
          ❆
          </div>
          <div class="snowflake">
          ❄
          </div>
          <div class="snowflake">
          ❅
          </div>
          <div class="snowflake">
          ❆
          </div>
          <div class="snowflake">
          ❄
          </div>

        <body style={{background: "black", height:0}}>
        <marquee behavior="alternate"><h2 class="text-shadow" style={{color: "DeepSkyBlue"}}>Dance On Snow</h2></marquee>

             <div class="flip-box">
              <div class="flip-box-inner">
                <div class="flip-box-front">
                  <h2>Dance On Snow<br />❄️</h2>
                </div>
                <div class="flip-box-back">
                  <h2>Dance On Snow<br />❄️</h2>
                </div>
              </div>
            </div>

        <div
        className="video mt-5"
        style={{
               position: "relative",
               paddingBottom: "56.25%" /* 16:9 */,
               paddingLeft: 480,
               height: 0
             }}
      >
        <iframe width="952" height="536" 
        src="https://www.youtube.com/embed/AfRTglQNMAc?autoplay=1" 
        frameborder="0" allow="accelerometer; allow=autoplay;
        clipboard-write; encrypted-media; gyroscope;
         picture-in-picture" allowfullscreen>
        </iframe>

        <small>Ski hard</small>

        <div style={{position: 'absolute', top: 12, left: -145}}>
            <table style={{backgroundColor: 'SteelBlue', width: 60}}>
              <tr>
                <th>Title</th>
                <th>YouTube</th>
              </tr>

              <tr>
                <td>NEVEITALIA Ski carving 5</td>
                <td><iframe width="140" height="79" src="https://www.youtube.com/embed/_rIQqf-5lng" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
              </tr>

              <tr>
                <td>NEVEITALIA Ski carving 7</td>
                <td><iframe width="140" height="79" src="https://www.youtube.com/embed/1f8sZAK84w0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
              </tr>

              <tr>
                <td>NEVEITALIA Ski carving 8</td>
                <td><iframe width="140" height="79" src="https://www.youtube.com/embed/9Qs-9zYRZr8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
              </tr>

              <tr>
                <td>NEVEITALIA Ski carving 9</td>
                <td><iframe width="140" height="79" src="https://www.youtube.com/embed/YnAjcYYP6gM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
              </tr>

              <tr>
                <td>NEVEITALIA Ski carving 10</td>
                <td><iframe width="140" height="79" src="https://www.youtube.com/embed/A0zYseQcwpY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
              </tr>
            </table>
          </div>
      </div>

          <div class="bg"></div>
            <div class="bg bg2"></div>
            <div class="bg bg3"></div>
            <div class="content">
          </div>
 
              <div class="snack-wrap">
                <input type="checkbox" class="snackclose animated" id="close"/><label class="snacklable animated" for="close"></label>  
                <div class="snackbar animated">
                  <big> By the way, I am an avid skier and ski instructor. ⛷️ ♡</big>
                </div>      
              </div>
        </body>
      </div>
    );
}
 
export default DanceOnSnow;

              